exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagefoot[data-v-bf61060a] {\n  margin-top: 50px;\n  border-top: 1px solid #e6e6e6;\n  padding: 14px 0;\n  font-size: 12px;\n  color: #737373;\n}\n.pagefoot a[data-v-bf61060a] {\n  font-size: 12px;\n  color: #128fae;\n  text-decoration: none;\n}\n.pagefoot > a[data-v-bf61060a]:not(:last-child) {\n  margin-right: 20px;\n}", ""]);

// exports
